import {
  MEMBER,
  downloadables,
  getTipoStrumento,
  isFlipchart,
  isSme,
  mappingCta,
  getMateria,
  getClassi,
  SCARICA,
  renderAutori,
} from 'utils'
import React, { useMemo, useState } from 'react'
import Link from 'next/link'
import EmbeddedVimeo from 'components/atomic/EmbeddedVimeo'
import Icon from 'components/atomic/Icon'
import Pills from 'components/atomic/Pills'
import dynamic from 'next/dynamic'
import { sendGTMData } from 'utils/gtm.js'
import { Button } from 'react-components/atoms'
import RegisterBox from 'components/RegisterBox'
import { useSelector } from 'react-redux'
import Login from 'components/atomic/Login'
import { Tassonomia } from 'react-components/molecules'

const Modal = dynamic(() => import('./atomic/Modal'))

const initialComunicazione = {
  stato: false,
  type: '',
}

const StrumentoSummary = React.memo((props) => {
  const { strumento, classes = '', id = '', onLogin = () => {} } = props

  const { utente } = useSelector((state) => state.utente)

  const [vimeoModal, setVimeoModal] = useState(false)
  const [login, setLogin] = useState(false)
  const [next, setNext] = useState('')
  const [comunicazione, setComunicazione] = useState(initialComunicazione)

  const classi = `strumento-summary ${classes}`

  const tipoStrumento = useMemo(() => getTipoStrumento(strumento), [strumento])

  const autoreLabel = renderAutori(strumento.utenti, 'strumento-summary')

  let cta = null

  const ctaLabel = strumento.cta ? strumento.cta : mappingCta[tipoStrumento.split(' ')[0]]

  const isDownloadable = downloadables.includes(tipoStrumento.split(' ')[0])

  const getLabelGTM = () => {
    let eventLabel = tipoStrumento.split(' ')[0]
    if (eventLabel == 'scheda') {
      eventLabel = 'scheda_didattica'
    }
    return eventLabel
  }

  const handleGTM = () => {
    if (ctaLabel == 'Acquista') {
      sendGTMData({
        event: 'GAevent',
        eventID: '18',
        eventCategory: 'conversioni',
        eventAction: ctaLabel.toGTMFormat(),
        eventLabel: getLabelGTM(),
        moreInfo: strumento.titolo.toGTMFormat(),
      })
    }
    if (ctaLabel == 'Scarica' || ctaLabel == 'Ascolta') {
      sendGTMData({
        event: 'GAevent',
        eventID: '15',
        eventCategory: 'interazione_contenuti',
        eventAction:
          ctaLabel.toGTMFormat() == 'scarica'
            ? 'download'
            : ctaLabel.toGTMFormat() == 'ascolta'
            ? 'listen'
            : ctaLabel.toGTMFormat(),
        eventLabel: getLabelGTM(),
        moreInfo: strumento.titolo.toGTMFormat(),
      })
    }
  }

  if (strumento.extra?.id_vimeo) {
    cta = (
      <Button
        className="strumento-summary__cta"
        label={ctaLabel}
        onClick={() => {
          setVimeoModal(true)
          handleGTM()
        }}
      />
    )
  } else if (strumento.extra.link_esterno || strumento.extra.file_url) {
    cta = (
      <a
        className="wbutton wbutton--primary wbutton--md strumento-summary__cta"
        download={
          isDownloadable
            ? isFlipchart(strumento)
              ? strumento.titolo + '.flipchart'
              : isSme(strumento)
              ? strumento.titolo + '.sme'
              : true
            : false
        }
        target="_blank"
        href={strumento.extra.link_esterno || strumento.extra.file_url}
        onClick={() => handleGTM()}
      >
        {ctaLabel === 'Scarica' ? <Icon id="download" classes="icon--download" /> : null}
        {ctaLabel}
      </a>
    )
  } else {
    cta = (
      <Button
        icon={ctaLabel === 'Scarica' ? <Icon id="download" classes="icon--download" /> : null}
        className="strumento-summary__cta disabled"
        label={ctaLabel}
        onClick={() => handleComunicazione(true)}
      />
    )
  }

  const handleLogin = (login, nextPage = '') => {
    if (nextPage) setNext(nextPage)
    setComunicazione(initialComunicazione)
    setLogin(login)
  }

  const handleComunicazione = () => {
    setComunicazione({ stato: true, type: SCARICA })
  }

  const renderComunicazione = (utente, item) => {
    if (item.con_codice) {
      return (
        <>
          <h3 className="title">Inserisci il codice ISBN e sblocca questo contenuto!</h3>
          <p className="disclaimer">
            Sotto il codice a barre del libro trovi il codice ISBN, inseriscilo per accedere subito
            a tutti i contenuti del libro.
          </p>
          {utente ? (
            <Link legacyBehavior href="/area-personale/libreria">
              <a className="button button--primary cta" type="button">
                Inserisci il codice
              </a>
            </Link>
          ) : (
            <button
              className="button button--primary cta"
              type="button"
              onClick={() => handleLogin(true, 'area-personale-libreria')}
            >
              Inserisci il codice
            </button>
          )}
        </>
      )
    } else if (!utente) {
      return (
        <>
          <h3 className="title">Questo contenuto è riservato agli utenti registrati.</h3>
          <p className="disclaimer">
            Registrati gratuitamente e scopri tutti i vantaggi. In regalo per te 30 giorni di prova
            a IO+, con tanti contenuti in esclusiva e l'accesso alla community dei docenti Giunti
            Scuola.
          </p>
          <Link legacyBehavior href="/registrazione">
            <a
              className="button button--primary cta"
              type="button"
              onClick={() => setComunicazione(initialComunicazione)}
            >
              Registrati ora
            </a>
          </Link>
          <p className="disclaimer">
            Registrati ora e accedi a tanti contenuti, <b>sempre aggiornati</b>
          </p>
          <p>
            Sei già registrato?{' '}
            <a className="login" onClick={() => handleLogin(true)}>
              Accedi
            </a>
          </p>
        </>
      )
    } else if (!utente.is_member) {
      return (
        <>
          <h3 className="title">
            Questo contenuto è riservato agli abbonati IO+, la community dei docenti Giunti Scuola.
          </h3>
          <p className="disclaimer">
            Provalo gratuitamente per 30 giorni, e scopri tutti i materiali a disposizione per te:
            percorsi didattici, materiali per le lezioni e molto altro.
          </p>
          <a className="button button--primary cta" type="button" href="/io-piu">
            Abbonati a io+
          </a>
          {/* <p className="disclaimer">
            per te, <b>30 giorni di prova gratuita</b>
          </p> */}
          <p>
            Sei già abbonato?{' '}
            <a className="login" onClick={() => handleLogin(true)}>
              Accedi
            </a>
          </p>
        </>
      )
    }

    return null
  }

  const hasPerm = strumento.extra.has_perm || true // di default nascondo il banner io+

  const materia = getMateria(strumento.tassonomia)
  const classe = getClassi(strumento.tassonomia).join('-')

  return (
    <>
      <div className={classi} id={id}>
        <Tassonomia
          label={tipoStrumento}
          iconName={`cat-${tipoStrumento.split(' ')[0]}`}
          materia={materia}
          classe={classe}
        />
        <h1 className="strumento-summary__title">{strumento.titolo}</h1>
        <div
          className="strumento-summary__abstract"
          dangerouslySetInnerHTML={{ __html: strumento.descrizione }}
        />
        {cta}
        {!hasPerm && strumento.membership === MEMBER && <RegisterBox />}
        <hr />
        <Pills classes="strumento-summary__pills" tassonomia={strumento.tassonomia} />
        {autoreLabel}
      </div>
      {vimeoModal && (
        <Modal
          isOpen={vimeoModal}
          alert={false}
          close={() => setVimeoModal(false)}
          classes="modal__content--wide"
        >
          <div className="modal__content__vimeo">
            <EmbeddedVimeo id={strumento.extra?.id_vimeo} />
          </div>
        </Modal>
      )}
      {comunicazione.stato && (
        <Modal
          isOpen={comunicazione.stato}
          alert={false}
          close={() => setComunicazione(initialComunicazione)}
          classes="modal__content--wide"
        >
          <div className="modal__content__comunicazione">
            {renderComunicazione(utente, strumento)}
          </div>
        </Modal>
      )}
      {login && <Login isOpen={login} next={next} setLogin={handleLogin} />}
    </>
  )
})

export default StrumentoSummary
